import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const LogSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('w-full px-4 py-2', className);

	// Render
	return (
		<ul className={rootClassName}>
			<li className='flex-start gap-4 py-2 w-full'>
				<span className='shrink-0 w-10'>
					<Skeleton />
				</span>
				<span className='w-1/2'>
					<Skeleton />
				</span>
			</li>
		</ul>
	);
};

export { LogSkeleton };

// Docs:
// https://github.com/dvtng/react-loading-s#readme
